import AuthProvider from "./AuthProvider.web";

export default AuthProvider;
